import { useCallback, useState } from "react";
import { useAppDispatch } from "../../hook";
import { getPersonas } from "../../user/userPersona/personaSlice";
import { attachRulebook } from "../rulebookAttachmentClient";
import resolveRulebookAttachFailure from "./resolveRulebookAttachFailure";
/** Attach submit for the attach-target picker: guards, persona refresh, and success or failure reporting. */
export default function useRulebookAttachSubmit({ rulebookId, ownerType, selectedTarget, isAlreadyAttached, isSelectedBlocked, onAttached, onClose, onSucceeded, onFailed, }) {
    const dispatch = useAppDispatch();
    const [stateIsAttaching, setStateIsAttaching] = useState(false);
    const handleSubmit = useCallback(() => {
        if (!selectedTarget || isAlreadyAttached || isSelectedBlocked || stateIsAttaching) {
            return;
        }
        const target = selectedTarget;
        setStateIsAttaching(true);
        attachRulebook({ rulebookId, ownerType, ownerId: target.id })
            .then((response) => {
            onSucceeded({ target, isCharacterTurnedNsfw: Boolean(response.character_turned_nsfw) });
            onAttached(target.id);
            // Keep persona.rulebook_id in the store fresh for chat consumers.
            if (ownerType === "persona") {
                void dispatch(getPersonas());
            }
            onClose();
        })
            .catch((error) => onFailed(resolveRulebookAttachFailure(error)))
            .finally(() => setStateIsAttaching(false));
    }, [
        selectedTarget,
        isAlreadyAttached,
        isSelectedBlocked,
        stateIsAttaching,
        rulebookId,
        ownerType,
        onSucceeded,
        onFailed,
        onAttached,
        onClose,
        dispatch,
    ]);
    return { isAttaching: stateIsAttaching, handleSubmit };
}
